/**
 * Set a date's time to the timeString time value
 * @param date
 * @param timeString - string as hours:minutes ie (23:00)
 */
export const setTimeValueFromString = (date: Date, timeString: string): Date => {
  const dateCopy = new Date(date.getTime());
  const [hours, minutes] = timeString.split(':');

  dateCopy.setHours(Number(hours), Number(minutes));

  return dateCopy;
};
